import * as React from 'react';
import { CodeItem } from 'app/area/codetable/item/types-store';
import { Numberbox } from 'ui';
import { CodetableMetadata } from 'app/area/codetable/types-store';
import { CodetableTranslation } from '../../constants';

interface CodeSequenceProps {
  codeItem: CodeItem;
  metadata: CodetableMetadata;
  onChange: (sequence: number) => void;
  translation: CodetableTranslation;
  readOnly?: boolean;
}

export const CodeSequence = ({ codeItem, metadata, onChange, translation, readOnly }: CodeSequenceProps) => {
  if (!metadata || !metadata.features || !metadata.features.sequence) {
    return null;
  }

  return <div className="col-lg-6 col-sm-12">
    <Numberbox
      componentId="code_sequence"
      readOnly={readOnly}
      label={translation ? { text: translation.sequence } : undefined}
      value={codeItem && codeItem.sequence}
      onChange={onChange}
      useThousand=" "
      maxValue={999999999}
      textInvalidRangeError={translation.must_be_within_range}
    />
  </div>;
};
